import { browser } from "$app/environment";
import { readable, writable } from "svelte/store";
export enum INavMode {
  FULL = "full",
  HIDE = "hide",
}
// Detect view
export enum Views {
  MOBILE = 0,
  TABLET = 1,
  DESKTOP = 2,
}

const DEBOUNCE_TIME = 10; //ms
const tabletBreakpoint = 768;
const desktopBreakpoint = 1024;

export const screenSize = readable(Views.DESKTOP, set => {
  if (!browser) {
    return;
  }

  let timeout!: NodeJS.Timeout;

  function resize() {
    const { innerWidth } = window;
    if (innerWidth < tabletBreakpoint) {
      set(Views.MOBILE);
    } else if (innerWidth >= tabletBreakpoint && innerWidth < desktopBreakpoint) {
      set(Views.TABLET);
    } else {
      // desktop
      set(Views.DESKTOP);
    }
  }
  resize();

  function delegate() {
    clearTimeout(timeout);
    timeout = setTimeout(() => resize(), DEBOUNCE_TIME);
  }
  window.addEventListener("resize", delegate);

  return function stop() {
    if (typeof window === "undefined") {
      return;
    }
    window.removeEventListener("resize", delegate);
  };
});

export const navbarMode = writable<INavMode>(INavMode.FULL);

export function setNavMod(value: INavMode) {
  navbarMode.set(value);
}
